import { createCommand } from '../../utils';
import { neighborSectionsQuery } from '../queries';
import { selectionFocusRequested } from '../state';
import { SelectRoadSectionCommand } from './SelectRoadSectionCommand';

// Previous / next section on the same axis, from the object sheet. Does nothing at the end of an axis.
export const SelectNeighborCommand = createCommand<'previous' | 'next'>(
    'MAP_V2/SELECT_NEIGHBOR',
    async (direction, { dispatch, getState }) => {
        const neighbor = neighborSectionsQuery(getState())[direction];
        if (neighbor) {
            await dispatch(SelectRoadSectionCommand(neighbor.id));
            dispatch(selectionFocusRequested());
        }
    },
);
